import React from 'react';
import { SmallBodyText, NavigationItem, BoldTinyBodyText, INavigationItemProps } from 'ui-toolkit';
import { ExternalUrlFactory } from 'ui-toolkit/rest/ExternalUrlFactory';
import styled from 'styled-components';
import { DisplayPartyType } from '../../../../../ui-toolkit/enums/ePartyType';
import { FullName, IParty } from '../../../../../ui-toolkit/orders/interfaces/IParty';
import { IHasTestData } from '../../../../../ui-toolkit/test-utilities/IHasTestData';
import { mergeTests } from '../../../../../ui-toolkit/test-utilities/mergeTests';

interface INameControlProps extends IHasTestData {
  party: IParty;
  navEditStart?: INavigationItemProps;
  showPartyType?: boolean;
  intent?: 'bold' | 'faded';
}

const EntityLabel = styled(BoldTinyBodyText)`
  margin-top: ${({ theme }) => theme.spacing.spacing2};
  margin-bottom: ${({ theme }) => theme.spacing.spacing2};
`;

export const NameControl: React.FC<INameControlProps> = ({
  party,
  navEditStart,
  showPartyType,
  'data-test-id': dataTestID,
  intent,
}) => {
  return (
    <SmallBodyText>
      {showPartyType ? (
        <EntityLabel data-test-id={mergeTests(dataTestID, 'type')}>{DisplayPartyType[party.type]}</EntityLabel>
      ) : null}
      <SmallBodyText intent={intent}>
        {navEditStart ? (
          <NavigationItem data-test-id={dataTestID} {...navEditStart} isPrimary={true} isInline={true} />
        ) : (
          <span
            data-test-id={party.id ? dataTestID : undefined}
            title={
              party.id
                ? undefined
                : `Please go to ${ExternalUrlFactory().urlFor.spruceHelpLinkUrl()} to submit a request for help`
            }
          >
            {FullName(party)}
          </span>
        )}
      </SmallBodyText>
    </SmallBodyText>
  );
};
